export default (params) => ({
  trigger: {
    name: 'active_mailer.open_overlay',
    params: params,
  },
  config: {
    schema: {
      sub_feature: {
        enum: [
          'order_block',
          'bottom_product_card',
          'sticky_header',
          'review_panel',
        ],
      },
    },
    event: {
      name: 'select_content',
      params: {
        content: 'keep_me_updated',
      },
    },
  },
});
